import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article11Doc } from '../individual';

export default function Article11() {
  return (
    <div className='emas__article11'>
        <Navbar />
        <Article11Doc />
        <Footer />
    </div>
  )
}
